const PDFViewer = ({ ariaLabel, scriptUrl, objHeight = "500" }) => (
  <object
    data={scriptUrl}
    aria-label={`${ariaLabel}-script`}
    className="w-100"
    height={objHeight}
  />
);
export default PDFViewer;
